import { Injectable, Type } from '@angular/core';
import { BankDialogComponent } from 'src/app/shared/components/bank-dialog/bank-dialog.component';
import { CompanyDialogComponent } from 'src/app/shared/components/company/company-dialog.component';
import { ItemDialogComponent } from 'src/app/shared/components/item-dialog/item-dialog.component';
import { TipoItemDialogComponent } from 'src/app/shared/components/tipo-item-dialog/tipo-item-dialog.component';
import { TipoMovimientoDialogComponent } from 'src/app/shared/components/tipo-movimiento-dialog/tipo-movimiento-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DataSetComponentService {
  COMPONENTS: any = {
    "TipoItemDialogComponent": TipoItemDialogComponent,
    "TipoMovimientoDialogComponent": TipoMovimientoDialogComponent,
    "BankDialogComponent": BankDialogComponent,
    "ItemDialogComponent": ItemDialogComponent,
    "CompanyDialogComponent": CompanyDialogComponent
  }

  get(name: string): any {
    return this.COMPONENTS[name];
  }
}
